import { CommonModule, DatePipe, NgIf } from '@angular/common'
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons'
import { DateInputCustomFormatPlaceholder, DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { WindowService } from '@progress/kendo-angular-dialog'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, RowClassArgs, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_ICONS } from '@progress/kendo-angular-icons'
import { CheckBoxDirective, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { LabelDirective } from '@progress/kendo-angular-label'
import { ToastrService } from 'ngx-toastr'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { UserStateService } from '../../../../@theme/services/user-state.service'
import { AuthRepDashComponent } from '../../../../components/authDash/authrepdash.component'
import { Assistant } from '../../../../models/repEditorModels'
import { UserInfo } from '../../../../models/userModels'
import { Utilities } from '../../../../utilities/utilities'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'
@Component({
    selector: 'gd-rep-editor-assistant',
    templateUrl: './rep-editor-assistant.component.html',
    styleUrls: ['./rep-editor-assistant.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        KENDO_ICONS,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        LabelDirective,
        CheckBoxDirective,
        KENDO_BUTTON,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        DropDownListComponent,
        DatePickerComponent,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        DatePipe,
        AdminOnlyDirective
    ]
})
export class RepEditorAssistantComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  @Input() override repId: number = 0
  repAssistant: Assistant[] = []
  public pendingSpinner = false
  public gridLoading = true
  public showOnlyActive = false
  activeAsisstants = this.repState.getActiveAssistantLookups()
  public asDateInput = (value) =>
    Utilities.asType<DateInputCustomFormatPlaceholder>(value)

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
    private userState: UserStateService,
    private router: Router,
    private toastr: ToastrService,
    private windowService: WindowService,
    protected cd: ChangeDetectorRef,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  /*   ngOnInit() {Ed
    this.StartLoading()
    this.cd.detectChanges()
  } */
  ngOnChanges() {
    this.StartLoading()
  }
  StartLoading() {
    // setTimeout(() => {
    this.checkGridState()
    //  }, 1000)
    if (!this.repState.repAssistants || !this.repState.repAssistantsActive) {
      //  setTimeout(() => {
      this.initGrid()
      //  }, 1000)
    } else {
      this.repAssistant = this.showOnlyActive
        ? this.repState.repAssistantsActive
        : this.repState.repAssistants
      this.gridLoading = false
      this.cd.detectChanges()
    }

    if (!this.repState.assistantLookups) {
      this.typesService.getAssistantLookups().subscribe((response) => {
        this.repState.assistantLookups = response
      })
      this.cd.detectChanges()
    }
  }
  initGrid() {
    this.gridLoading = true
    this.pendingSpinner = true
    this.clientService
      .getAssistantForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repAssistants = response.map(
          (assistant) => new Assistant(assistant),
        )
        this.repState.repAssistantsActive = this.repState.repAssistants.filter(
          (a) => a.active,
        )
        this.repAssistant = this.showOnlyActive
          ? this.repState.repAssistantsActive
          : this.repState.repAssistants
        
        // Always hide loaders after processing, even if no data
        this.pendingSpinner = false
        this.gridLoading = false
        this.cd.detectChanges()
      })
    this.cd.detectChanges()
  }
  public category(id: number): any {
    return this.activeAsisstants.find((x) => x.assistantLevelID === id)
  }
  public addHandler({ sender }) {
    const newAssistant = new Assistant(null)
    newAssistant.repId = this.repId
    newAssistant.active = true
    this.addHandlerShared({ sender }, newAssistant)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const assistant = new Assistant(formGroup.value)
    this.clientService.submitAssistantUpdate(assistant).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new Assistant(dataItem)
    itemToRemove.active = false
    itemToRemove.hasWebAccess = false
    this.clientService.submitAssistantUpdate(itemToRemove).subscribe(() => {
      this.initGrid()
    })
  }

  public rowCallback(context: RowClassArgs) {
    const assistant = context.dataItem
    if (!assistant.active) {
      return {
        inactive: true,
      }
    } else 
      return null;
  }

  public toggleViewActive() {
    this.showOnlyActive = !this.showOnlyActive
    this.repAssistant = this.showOnlyActive
      ? this.repState.repAssistantsActive
      : this.repState.repAssistants
  }

  public goToMembership(dataItem) {
    if (!dataItem) {
      this.toastr.error('Assistant data is missing.', 'Error');
      return;
    }
    if (!dataItem.assistantEmail) {
      this.toastr.error('Assistant email is required to grant web access.', 'Error');
      return;
    }
    if (!dataItem.assistantName) {
      this.toastr.error('Assistant name is required to grant web access.', 'Error');
      return;
    }

    const assistant = dataItem as Assistant
    const repId = Number(assistant.repId)
    const nameParts = assistant.assistantName.trim().split(' ')
    const firstName = nameParts[0] || ''
    const lastName = nameParts.slice(1).join(' ') || ''
    const phonenumber = assistant.phoneNumber || ''
       const userrole = assistant.userRole || ''
    
    this.userState.currentUserInfo = new UserInfo({
      email: dataItem.assistantEmail,
      firstName: firstName,
      lastName: lastName,
      roles: [assistant.userRole],
      branchlist: [],
      repId: repId,
      phoneNumber: phonenumber,
    })

    // Open dialog popup instead of navigating
    const windowRef = this.windowService.open({
      title: dataItem.hasWebAccess ? 'Edit Membership' : 'Grant Web Access',
      content: AuthRepDashComponent,
      width: 900,
      height: 600,
    })

    // Pass the dialog mode to the component
    const dashInstance = windowRef.content.instance as AuthRepDashComponent
    dashInstance.dialogMode = dataItem.hasWebAccess ? 'edit' : 'create'

    windowRef.result.subscribe(() => {
      this.initGrid()
    })
  }

  public createFormGroup(assistant: Assistant): UntypedFormGroup {
    return this.formBuilder.group({
      repId: [assistant.repId],
      active: [assistant.active],
      assistantEmail: [
        assistant.assistantEmail,
        [Validators.required, Validators.email],
      ],
      assistantEndDate: [assistant.assistantEndDate],
      assistantId: [assistant.assistantId],
      assistantName: [assistant.assistantName, Validators.required],
      assistantStartDate: [assistant.assistantStartDate, Validators.required],
      asstReg: [assistant.asstReg],
      fingerPrintReceived: [assistant.fingerPrintReceived],
      fingerPrintRequired: [assistant.fingerPrintRequired],
      hasWebAccess: [assistant.hasWebAccess],
      infoLevel: [assistant.infoLevel],
      infoLevelId: [assistant.infoLevelId, Validators.required],
      receiveAlerts: [assistant.receiveAlerts],
      receiveApprovals: [assistant.receiveApprovals],
    })
  }
}
